export default "__VITE_ASSET__hhgVfzxC__"